module.exports = __webpack_public_path__ + "klue-icon-727748a0de9553f5a65ff68f7c37e90a.png";